import { render, staticRenderFns } from "./quickManage.vue?vue&type=template&id=5fb5f7ba&scoped=true"
import script from "./quickManage.vue?vue&type=script&lang=js"
export * from "./quickManage.vue?vue&type=script&lang=js"
import style0 from "./quickManage.vue?vue&type=style&index=0&id=5fb5f7ba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb5f7ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fb5f7ba')) {
      api.createRecord('5fb5f7ba', component.options)
    } else {
      api.reload('5fb5f7ba', component.options)
    }
    module.hot.accept("./quickManage.vue?vue&type=template&id=5fb5f7ba&scoped=true", function () {
      api.rerender('5fb5f7ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/workbench/components/quickManage.vue"
export default component.exports